<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="80">
				<Select v-model="formValidate.checkStatus" clearable style="width:200px">
					<Option :value="0" key="0">待审核</Option>
					<Option :value="1" key="1">审核不通过</Option>
					<Option :value="2" key="2">审核通过</Option>
				</Select>
			</FormItem>
			</Col>

			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户名" :label-width="100">
				<Input v-model="formValidate.name" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户id" :label-width="100">
				<Input v-model="formValidate.userId" clearable />
			</FormItem>
			</Col>

			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="企业名称" :label-width="80">
				<Input v-model="formValidate.company" clearable />
			</FormItem>
			</Col>


			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				apps: [],
				events: [],
				appId: '',
				advertType: 'table',
				formValidate: {
					checkStatus: undefined,
					name: undefined,
					userId: undefined,
					company: '',
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {

		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					checkStatus: undefined,
					name: undefined,
					userId: undefined,
					company: '',
				}
				//this.formSubmit()
			},
			getFormData() {
				const formData = {
					checkStatus: this.formValidate.checkStatus,
					name: this.formValidate.name,
					userId: this.formValidate.userId,
					company: this.formValidate.company,
				}
				return formData
			},

		}
	}
</script>